import {createEvent} from '../../../../../../common/createEvent.function';
import {AutoTapSpeed} from '../type/AutoTapSpeed.enum';
import {AutoTapType} from '../type/AutoTapType.enum';
import {EventType} from '../type/EventType.enum';
import {SceneKey, TalkGroupKey, TalkKey} from '../type/KeyType.type';

export const events = {
  backgroundTapPressed: () => createEvent(EventType.BackgroundTapPressed),
  backgroundLongTapPressed: () =>
    createEvent(EventType.BackgroundLongTapPressed),
  talkTapPressed: (talkId: TalkKey) =>
    createEvent(EventType.TalkTapPressed, {talkId}),
  talkLongTapPressed: (talkId: TalkKey) =>
    createEvent(EventType.TalkLongTapPressed, {talkId}),
  endOfTalkReached: () => createEvent(EventType.EndOfTalkReached),
  viewerPulledDown: () => createEvent(EventType.ViewerPulledDown),
  viewerPulledUp: () => createEvent(EventType.ViewerPulledUp),
  viewerSwipedUp: () => createEvent(EventType.ViewerSwipedUp),
  viewerSwipedDown: () => createEvent(EventType.ViewerSwipedDown),
  viewerPaused: () => createEvent(EventType.ViewerPaused),
  tutorialTapPressed: () => createEvent(EventType.TutorialTapPressed),
  replayBoxTapPressed: (talkId: TalkKey) =>
    createEvent(EventType.ReplayBoxTapPressed, {talkId}),
  productExposedAreaChanged: (
    topTalkId: TalkKey,
    bottomTalkId: TalkKey,
    scrollOffset: number
  ) =>
    createEvent(EventType.ProductExposedAreaChanged, {
      topTalkId,
      bottomTalkId,
      scrollOffset,
    }),
  autoTapChangeStatusTapPressed: (autoTapType: AutoTapType) =>
    createEvent(EventType.AutoTapChangeStatusTapPressed, {autoTapType}),
  autoTapChangeSpeedTapPressed: (autoTapSpeed: AutoTapSpeed) =>
    createEvent(EventType.AutoTapChangeSpeedTapPressed, {
      autoTapSpeed,
    }),
  mutedToggleTapPresssed: () => createEvent(EventType.MutedToggleTapPresssed),
  mediaEnded: (talkId: TalkKey) => createEvent(EventType.MediaEnded, {talkId}),
  fullscreenHideRequested: () => createEvent(EventType.FullscreenHideRequested),
  viewerMenuExposedToggleTapPressed: () =>
    createEvent(EventType.ViewerMenuExposedToggleTapPressed),
  fullscreenImageTapPressed: () =>
    createEvent(EventType.FullscreenImageTapPressed),
  leaveAndMoveOnToTheNextTrigerred: () =>
    createEvent(EventType.LeaveAndMoveOnToTheNextTrigerred),
  forceProcessToTalkId: (talkId: TalkKey) =>
    createEvent(EventType.ForceProcessToTalkId, {talkId}),
  forceProcessToTalkGroupId: (talkGroupId: TalkGroupKey) =>
    createEvent(EventType.ForceProcessToTalkGroupId, {talkGroupId}),
  forceProcessToSceneId: (sceneId: SceneKey) =>
    createEvent(EventType.ForceProcessToSceneId, {sceneId}),
};
